<template>
  <div>
    <div v-for="(line, index) in result.lines" :key="index">{{ line }}</div>
    <div v-if="result.postcode">{{ result.postcode }}</div>
    <div v-if="result.country">{{ result.country }}</div>
  </div>
</template>

<script>
export default {
  name: "Address",
  props: {
    result: Object,
  },
};
</script>
